<template>
  <div class="driverTaskDetail">
    <el-drawer
      size="890px"
      title="管理项目"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <!-- <basic-container> -->
      <div class="infos">
        <div style="margin-bottom: 20px; width: 50%">
          <el-input
            placeholder="输入项目名称搜索"
            v-model="paramsSearch.projectName"
            @input="paramsSearch.type = ''"
            class="input-with-select"
          >
            <el-select
              v-model="paramsSearch.type"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="全部项目" value=""></el-option>
              <el-option label="已添加" value="1"></el-option>
              <el-option label="未添加" value="2"></el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getPage()"
            ></el-button>
          </el-input>
        </div>
        <avue-crud
          ref="crud"
          :data="tableData"
          :table-loading="tableLoading"
          :option="tableOption"
          @on-load="getPage"
          @refresh-change="refreshChange"
          @search-change="searchChange"
          @selection-change="selectionChange"
        >
          <template slot="projectName" slot-scope="scope">
            <div class="info-text">
              {{ scope.row.projectName }}
              <div class="tag" v-if="scope.row.existInProject">已添加</div>
            </div>
          </template>
          <template slot="menu" slot-scope="scope">
            <el-button
              v-if="!scope.row.existInProject"
              type="primary"
              icon="el-icon-plus"
              style="padding: 8px !important"
              size="small"
              @click="add(scope.row, scope.index)"
            >
              添加
            </el-button>
            <el-button
              type="text"
              v-if="scope.row.existInProject"
              size="small"
              plain
              @click="del(scope.row, scope.index)"
            >
              移出
            </el-button>
          </template>
          <template slot="header" slot-scope="scope">
            <el-button
              style="margin: 8px !important"
              type="primary"
              :disabled="selectList.length == 0"
              icon="el-icon-plus"
              size="mini"
              @click="batchAdd(scope.row, scope.index)"
            >
              批量添加项目
            </el-button>
            <el-button
              style="margin: 8px !important"
              :disabled="selectList.length == 0"
              type="primary"
              size="mini"
              icon="el-icon-delete"
              @click="batchDel(scope.row, scope.index)"
            >
              批量移出项目
            </el-button>
          </template>
        </avue-crud>
      </div>

      <!-- </basic-container> -->
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getDetail2,
  checkStaffOnWork,
  getProjectList,
} from "@/api/chain/companystaff";
import { expotOut } from "@/util/down.js";
import { batchUpdatemember } from "@/api/chain/projectinfo";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    info: {},
  },
  data() {
    return {
      projectList: [],
      tableData: [],
      paramsSearch: {
        type: "",
        projectName: "",
      },
      tableLoading: false,
      tableOption: {
        dialogDrag: false,
        border: true,
        indexLabel: "序号",
        // stripe: true,
        align: "left",
        searchShow: false,
        labelWidth: 150,
        searchLabelWidth: 86,
        searchSpan: 8,
        excelBtn: false,
        printBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchMenuSpan: 8,
        menu: true,
        selection: true,
        menuWidth: 160,
        menuAlign: "center",
        page: false,
        column: [
          {
            label: "项目名称",
            prop: "projectName",
            search: true,
            searchSpan: 16,
            overHidden: true,
          },
        ],
      },
      selectList: [],
    };
  },
  created() {},
  mounted() {
    this.getPage();
    getProjectList().then((res) => {
      this.projectList = res.data.data;
      this.projectList.unshift({
        projectName: "全部项目",
        id: "",
      });
    });
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    changeProject(val) {
      this.getPage();
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.getPage(params);
      done();
    },
    getPage(params = {}) {
      console.log(params);
      console.log(this.paramsSearch);
      let data = Object.assign(params, this.paramsSearch);
      data.staffId = this.info.id;
      this.tableLoading = true;
      getDetail2(data)
        .then((response) => {
          console.log("response", response);
          this.tableData = response.data.data;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * 刷新回调
     */
    refreshChange() {
      this.getPage();
    },
    selectionChange(e) {
      this.selectList = e;
    },
    add(row) {
      this.$confirm(`是否添加${row.projectName}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          console.log(row);
          console.log(this);
          this.handleUpdate([row.id], [this.info.id], 1);
        })
        .catch(() => {});
    },
    del(row) {
      this.checkStaffOnWork(
        [row.id],
        [this.info.id],
        2,
        `是否移出${row.projectName}？`
      );
    },
    batchAdd() {
      let ids = this.selectList.map((item) => item.id);
      this.$confirm(`确定批量添加项目？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          this.handleUpdate(ids, [this.info.id], 1);
        })
        .catch(() => {});
    },
    batchDel() {
      let ids = this.selectList.map((item) => item.id);
      this.checkStaffOnWork(ids, [this.info.id], 2, `确定批量移出项目？`);
    },
    changeTab() {
      this.tableData = [];
      this.getPage();
    },
    checkStaffOnWork(projectInfoIdList, memberIdList, type, text) {
      checkStaffOnWork({ projectInfoIdList, memberIdList, type }).then(
        (res) => {
          if (res.data.code == 789) {
            this.$confirm(res.data.msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.handleUpdate(projectInfoIdList, memberIdList, type);
              })
              .catch(() => {});
          } else {
            this.$confirm(text, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then((res) => {
                this.handleUpdate(projectInfoIdList, memberIdList, type);
              })
              .catch(() => {});
          }
        }
      );
    },
    handleUpdate(projectInfoIdList, memberIdList, type) {
      console.log(projectInfoIdList);
      console.log(memberIdList);
      this.tableLoading = true;
      batchUpdatemember({ projectInfoIdList, memberIdList, type })
        .then((res) => {
          this.tableLoading = false;
          this.getPage();
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .avue-crud__pagination {
  display: none;
}
.infos {
  padding: 32px;
}
/deep/.avue-crud__menu {
  display: none;
}
/deep/ .el-table__header th.is-leaf {
  background: #edeff0;
  border-width: 1px;
}
/deep/.el-table__header-wrapper {
  border-bottom: none;
}
/deep/.el-drawer__header {
  padding: 11px 20px;
  box-shadow: 0px 1px 0px 0px #ededf0;
  margin-bottom: 0;
}
.tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 24px;
  background: #ffffff;
  border-radius: 3px;
  border: 1px solid #35b1ff;
  font-weight: 400;
  font-size: 12px;
  color: #35b1ff;
  margin-left: 6px;
  line-height: 24px;
}
.info-text {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
}
/deep/ .el-select {
  margin: 0 !important;
  .el-input--medium .el-input__inner {
    height: 34px !important;
    line-height: 34px !important;
  }
}
</style>
